import { LanguageType } from 'types/enums';
import { useSurveyContext } from '../components/SurveyContext';

export const SurveySuccessPage = () => {
	const { language } = useSurveyContext();
	const dictionary = DICTIONARY[language];

	return (
		<>
			<div className="flex flex-col p-8 sm:pt-12 md:pt-20 md:w-[756px] mx-auto">
				<div className="flex flex-col gap-4 items-center sm:gap-6 p-4 sm:p-6 bg-white rounded-lg shadow-normal">
					<h1 className="text-2xl sm:text-4xl font-semibold">
						{dictionary.thankYouMessage}
					</h1>
					<p className="text-sm sm:text-lg">{dictionary.closeWindow}</p>
				</div>
			</div>
		</>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		thankYouMessage: 'Thank you for submitting the survey',
		closeWindow: 'You can now close the window'
	},
	[LanguageType.Norwegian]: {
		thankYouMessage: 'Takk for at du sendte inn undersøkelsen',
		closeWindow: 'Du kan nå lukke vinduet'
	}
};
